import React from 'react'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'

const ReceivableFinancing2PageUI = ({ context, account, receivableFinancingList, onRefreshClick }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} centered={!account}
    account={account} page='receivableFinancing'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <LRTableActionsUI location='top'
        left={
          <div className='g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Receivable Financing</b></span>
          </div>
        }
        right={<span />}
      />
    }
    {
      receivableFinancingList && receivableFinancingList.length > 0 &&
      <ReceivableFinancingUI receivableFinancingList={receivableFinancingList} />
    }
  </SuperUserAccountPageUI>

const ReceivableFinancingUI = ({ receivableFinancingList }) =>
  <table>
    <thead>
      <tr>
        <th>S no.</th>
        <th>Disbursed</th>
        <th>Month</th>
        <th>From Account</th>
        <th>Debtor</th>
        <th>Invoice</th>
        <th>Amount</th>
        <th>Disbursed</th>
        <th>Fees</th>
        <th>DueDate</th>
        <th>Collected</th>
        <th>Amount</th>
        <th>Margin Money</th>
        <th>Date</th>
        <th>Principle Returned</th>
        <th>Interest</th>
        <th>Days</th>
        <th>Interest Rate</th>
      </tr>
    </thead>
    <tbody>
      {
        receivableFinancingList.map((rf, i) =>
          <tr className='acc' key={i}>
            <td className='left g_sticky_left'>
              <span className='g_m_right_50'>{i + 1}</span>
              <span className='g_no_wrap_2 g_m_right_50'>{rf.debtorName}</span>
            </td>
            <td>{rf.disbursementDateISO}</td>
            <td>{rf.disbursementMonth}</td>
            <td>{rf.disbursementTransferFromAccount}</td>
            <td>{rf.debtorName}</td>
            <td>{rf.invoiceNumber}</td>
            <td>{rf.invoiceAmount}</td>
            <td>{rf.dibursementAmount}</td>
            <td>{rf.transactionFeesWithGSTF5}</td>
            <td>{rf.dueDateForCollectionISO}</td>
            <td>{rf.collectionDateISO}</td>
            <td>{rf.collectionAmountF5}</td>
            <td>{rf.marginMoneyF5}</td>
            <td>{rf.dateOfMarginMoneyISO}</td>
            <td>{rf.principleReturnedToClimeF5}</td>
            <td>{rf.interest}</td>
            <td>{rf.days}</td>
            <td>{rf.interestRateP}</td>
          </tr>
        )
      }
    </tbody>
  </table>

export default ReceivableFinancing2PageUI
